module.exports = __webpack_public_path__ + "img/frame_note_titlebg.002124a3.png";